import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { SCHOOLS_IN_RED_STATUS } from "./apiRoutes";

// Define the expected response type
interface SchoolInRedStatus {
  schoolName: string;
  regionHead: string;
  relationshipManager: string;
}

interface SchoolsInRedStatusResponse {
  data: { items: SchoolInRedStatus[] };
}

const fetchSchoolsInRedStatus = async () => {
  const response = await axiosAuth.get<SchoolsInRedStatusResponse>(SCHOOLS_IN_RED_STATUS);
  return response.data;
};

export const useGetSchoolsInRedStatusQuery = (
  queryParams?: UseQueryOptions<SchoolsInRedStatusResponse, Error, SchoolsInRedStatusResponse, ["schoolsInRedStatus"]>
) =>
  useQuery<SchoolsInRedStatusResponse, Error, SchoolsInRedStatusResponse, ["schoolsInRedStatus"]>({
    queryKey: ["schoolsInRedStatus"],
    queryFn: fetchSchoolsInRedStatus,
    ...(queryParams as any),
  });
